import config from '../../config';

import { getAccessTokenClient, getApiKeyClient } from '../client/http';

const {
  apiBaseUrl: { elements: baseUrl },
} = config;

const accessTokenClient = () => getAccessTokenClient(baseUrl);
const apiKeyClient = () => getApiKeyClient(baseUrl);

export const analyseAll = async (eventId: string, isPublic?: boolean) => {
  try {
    const client = isPublic ? apiKeyClient : accessTokenClient;
    await client().get(`api/analyse/${eventId}`);
    return { success: true };
  } catch (err: any) {
    throw new Error(
      err.response?.data ?? "Couldn't start analysis, please try again later",
      err,
    );
  }
};
